var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileContainer",
    { class: _vm.$style.container },
    [
      _c(
        "MobileHeader",
        { attrs: { slot: "header", "nav-action": "home" }, slot: "header" },
        [_vm._v("\n    Burger Boss - " + _vm._s(_vm.restaurant.city) + "\n  ")]
      ),
      _vm._v(" "),
      _c("div", { class: _vm.$style.main }, [
        _c("div", { class: _vm.$style.mainTop }, [
          _c("p", { class: _vm.$style.welcomText }, [
            _vm._v(
              "\n        Welcome Back, " +
                _vm._s(_vm._f("capitalize")(_vm.user.firstName)) +
                "!\n      "
            )
          ]),
          _vm._v(" "),
          _c("p", { class: _vm.$style.lastOrdersText }, [
            _vm._v("\n        Here’s your last 5 orders\n      ")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$style.mainBottom },
          [
            _vm.isOrdersLoaded
              ? _c(
                  "VList",
                  { class: _vm.$style.ordersList },
                  _vm._l(_vm.lastFiveOrders, function(order, index) {
                    return _c(
                      "VListTile",
                      {
                        key: index,
                        class: _vm.$style.ordersListItem,
                        attrs: { ripple: "" }
                      },
                      [
                        _c("Order", {
                          attrs: { order: order },
                          on: { "save-to-cart": _vm.saveToCart }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobilePastOrders.vue?vue&type=template&id=32c585d9&
// module id = null
// module chunks = 